<template>
  <div>
    <div>
      <remark-card
        v-if="firstRemark"
        :open-reply="true"
        :show-context="true"
        :show-period="true"
        v-bind="firstRemark"
      ></remark-card>
    </div>
    <div>
      <check-list
        v-if="firstCheckList"
        ref="checkList"
        :open-reply="true"
        :show-period="true"
        default-comments-visibility-state="all"
        v-bind="firstCheckList"
      ></check-list>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import { mapActions, mapGetters, mapState } from 'vuex'

import RemarkCard from './remarks/remark-card'
import CheckList from './checks/check-list'
import useCheckHelpers from '@app/application/communication/sections/communication/composables/use-check-helpers'

const CommunicationItem = {
  setup() {
    return {
      ...useCheckHelpers(),
    }
  },

  data() {
    return {
      anchorElementScrolled: false,
      newRemarkId: null,
    }
  },

  created() {
    this.fetchCommunication()
    this.fetchMentionUsernames()
    // Event handlers
    window.eventHub.$on('refreshCommunicationData', this.fetchCommunication)
    window.eventHub.$on('resetCommunicationData', this.resetCommunicationData)
  },

  beforeUnmount() {
    window.eventHub.$off('refreshCommunicationData', this.fetchCommunication)
    window.eventHub.$off('resetCommunicationData', this.resetCommunicationData)
  },

  methods: {
    ...mapActions([
      'fetchCommunication',
      'fetchMentionUsernames',
      'resetCommunicationData',
      'toggleItemMode',
    ]),
  },

  computed: {
    ...mapGetters([
      'notes',
      'todos',
      'checkListChecks',
      'communicationItemType',
      'communicationItemId',
    ]),

    ...mapState({
      checkLists: (state) => state.checks.checkLists,
      storeLedgerId: (state) => state.ledgerId,
    }),

    firstRemark() {
      return _.first(_.union(_.toArray(this.notes), _.toArray(this.todos)))
    },

    firstCheckList() {
      return _.first(_.toArray(this.checkLists))
    },
  },

  components: {
    RemarkCard,
    CheckList,
  },
}

export default CommunicationItem
</script>
